const API_BASE =
  process.env.REACT_APP_API_BASE || "https://api.globalwineinstitute.org";

const DEFAULTS = {
  "surveys.onboarding_required": true,
  "surveys.paywall_offer": true,
  "surveys.dashboard_card": true,
  "surveys.profile_nudge": true,
  "surveys.email_campaigns": false,
};

const FLAG_KEY_MAP = {
  "surveys.onboarding_required": "onboarding_required",
  "surveys.paywall_offer": "paywall_enabled",
  "surveys.dashboard_card": "surveys_enabled",
  "surveys.profile_nudge": "surveys_enabled",
  "surveys.email_campaigns": "surveys_enabled",
};

let serverFlags = null;
let fetchPromise = null;

export function loadServerFlags() {
  if (fetchPromise) return fetchPromise;
  fetchPromise = fetch(`${API_BASE}/api/flags`)
    .then((r) => (r.ok ? r.json() : {}))
    .then((data) => {
      serverFlags = data || {};
      try {
        sessionStorage.setItem("ff_server", JSON.stringify(serverFlags));
      } catch (_) {}
      return serverFlags;
    })
    .catch(() => {
      try {
        const cached = sessionStorage.getItem("ff_server");
        if (cached) serverFlags = JSON.parse(cached);
      } catch (_) {}
      return serverFlags || {};
    });
  return fetchPromise;
}

function getServerFlag(key) {
  if (!serverFlags) {
    try {
      const cached = sessionStorage.getItem("ff_server");
      if (cached) serverFlags = JSON.parse(cached);
    } catch (_) {}
  }
  if (!serverFlags) return null;

  const serverKey = FLAG_KEY_MAP[key];
  if (!serverKey) return null;

  if (serverKey in serverFlags) return serverFlags[serverKey];
  return null;
}

export function getSurveyFlag(key) {
  const server = getServerFlag(key);
  if (server === false) return false;

  try {
    const override = localStorage.getItem(`ff_${key}`);
    if (override !== null) return override === "true";
  } catch (_) {}
  return DEFAULTS[key] ?? false;
}

export function setSurveyFlag(key, value) {
  localStorage.setItem(`ff_${key}`, String(!!value));
}

export function clearLocalOverrides() {
  Object.keys(DEFAULTS).forEach((key) => {
    try { localStorage.removeItem(`ff_${key}`); } catch (_) {}
  });
}
